module.exports = __webpack_public_path__ + "static/img/star_aura.3b6b0c75.png";